import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { styled } from '@mui/system';
import { useState, useEffect, useRef } from 'react';

function PopupUpHover({ children, rowData }) {
  const [anchor, setAnchor] = useState(null);
  const popupRef = useRef(null);

  const handleMouseEnter = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchor(null);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target) && !event.target.closest('.tableDot')) {
      setAnchor(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const open = Boolean(anchor);
  const id = open ? 'simple-popup' : undefined;

  return (
    <div className='popuphover-main-div' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className='flex align-items-center gap-2 '>
        <span className='branch-txt'>{rowData?.courseBranchesCount}</span>
      </div>
      {open && rowData?.courseBranchesCount>=1 &&  (
        <BasePopup id={id} open={open} anchor={anchor} className='hover-pop'>
          <PopupBody className='main-div' id='main-div' ref={popupRef}>
            <div>
              {children}
            </div>
          </PopupBody>
        </BasePopup>
      )}
    </div>
  );
}

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};


const PopupBody = styled('div')(
  ({ theme }) => `
  width: max-content; 
  height: max-content;  
  padding: 14px 16px 18px 16px;
  margin-right: 300px;
  margin-top: -20px;
  border-radius: 8px;
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  box-shadow: ${
    theme.palette.mode === 'dark'
      ? `0px 4px 8px rgb(0 0 0 / 0.7)`
      : `0px 4px 8px rgb(0 0 0 / 0.1)`
  };
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  z-index: 1;
`,
);

export default PopupUpHover;
